module.exports = __webpack_public_path__ + "static/img/cont607.442a086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont607.jpg
// module id = e3Pv
// module chunks = 0